// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"d379ae51","265":"2e09c527","271":"e533bfae","331":"c47a9e9d","409":"d2ecd204","444":"9ff10b26","463":"78d99dc8","472":"b709e022","473":"d6d7fbf6","892":"63949067","924":"e642b812","957":"f3133653"}[chunkId] + ".chunk.js";
};